import { createPinia } from "pinia"

export default () => {
  return createPinia()
}
